<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
  <div class="form-group row">
    <div class="col-md-10">
      <yt-input
        [Type]="'text'"
        [Label]="'STATUSRO.NAZIV.SINGULAR'"
        name="txtNaziv"                
        #autofocus
        autocomplete="off"
        #Naziv
        [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
        formControlName="Naziv"
        >
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
        <span *ngFor="let validation of errorMessages.Naziv">
          <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)">
            <span translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-form-label col-2"><span translate="STATUSRO.PRIVREMEN.SINGULAR"></span></label>
    <div class="col-md-1">
      <input
        style="width: 20px;"
        type="checkbox"
        name="txtPrivremen"
        class="form-control"
        formControlName="Privremen"
        autocomplete="off"
        >
    </div>
  </div>
  <div class="form-group row">
    <label class="col-form-label col-2"><span translate="STATUSRO.IDEUOBRACUN.SINGULAR"></span></label>
      <div class="col-md-1">
        <input
          style="width: 20px;"
          type="checkbox"
          name="txtIdeUObracun"
          class="form-control"
          formControlName="IdeUObracun"
          autocomplete="off"
          >
      </div>
    </div>
  </form>
